// Import action types related to sports scores
import {
  SPORTSCORE_FETCH_DATA_SUCCESS,
  SPORTSCORE_HAVE_ERROR,
  SPORTSCORE_ARE_LOADING,
} from "../actionType";

// Define the initial state for the SportScore reducer
const initialState = {
  data: [], // Initialize data as an empty array
  loading: true, // Set loading to true initially
  error: [], // Initialize error as an empty array
};

// Reducer function to handle sports score-related actions and update state accordingly
export function SportScoreReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching sports scores
    case SPORTSCORE_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when sports scores are being fetched
    case SPORTSCORE_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when sports scores are successfully fetched
    case SPORTSCORE_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.sportScore, // Update the data state with the fetched sports scores
        loading: false, // Set loading to false since the request is complete
        error: [], // Clear any previous errors (assuming the success case means no error)
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
